import BaseEvaluator from './BaseEvaluator';

export default class StringEqualsEvaluator extends BaseEvaluator {
  constructor(fieldName, friendlyFieldName, model, mutator = null) {
    super(fieldName, friendlyFieldName, model, mutator);
    this.evaluatorName = 'string_equals';
  }

  validate() {
    // this.mutator[1] = this.mutator[0]; // eslint-disable-line
    // this.mutator[0] = null; // Hack to validate any type of number against super class
    this.isValid = this.value === this.mutator[0];
    return this.isValid;
  }

  getMessage(validatorDictionary) {
    if (this.isValid) {
      return {
        type: 'valid',
        message: '',
      };
    }
    const func = validatorDictionary[this.evaluatorName];
    return {
      type: 'error',
      message: func(),
    };
  }
}
